import { Component, OnInit,Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal/modal.component';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'modal-disclaimer',
    templateUrl: '../../templates/partials/modal-disclaimer-mail.html'
})

export class ModalDisclaimerMailComponent implements OnInit {

    @Input() showModal;
    @Input() data;
    @Output() emitCloseModal = new EventEmitter();
    public id;
    @ViewChild('disclaimerMailModal') public assignModal:ModalDirective;
    constructor() {}

    public closeModal():void{
        this.emitCloseModal.emit({action:"close", data: null});
    }

    public onHidden():void {
        this.emitCloseModal.emit({action:"close", data: null});
    }

    public sendPaymentLink(): void {
        this.emitCloseModal.emit({action:"close", data: this.data});
    }

    ngOnInit() { }

    ngOnChanges() {
        (this.showModal) ? this.assignModal.show() : this.assignModal.hide();
    }
}


// WEBPACK FOOTER //
// ./src/app/modules/users/components/dummy/modal-disclaimer-mail.component.ts